import React from 'react';
import { Link } from 'react-router-dom';
import './WxappPage.css';

function WxappPage() {
  return (
    <div className="container">
      <header>
        <h1>雪排行</h1>
        <p className="subtitle">根据您的喜好、位置和天气，推荐最个性化的滑雪场排行</p>
      </header>

      <main>
        <section className="features">
          <div className="feature-item">
            <h3>个性化推荐</h3>
            <p>基于多维度数据，为您推荐最适合的滑雪场</p>
          </div>
          <div className="feature-item">
            <h3>智能排序</h3>
            <p>考虑雪道难度、缆车数量、海拔等多个因素</p>
          </div>
          <div className="feature-item">
            <h3>实时天气</h3>
            <p>关注降雪量、雪季长度等气候指标</p>
          </div>
        </section>

        <section className="qrcode">
          <h2>立即体验</h2>
          <img src="qrcode.jpg" alt="雪排行小程序二维码" />
          <p>微信扫码，打开小程序</p>
        </section>
      </main>

      <div style={{ marginTop: '20px' }}>
        <Link to="/" className="map-link">返回地图</Link>
      </div>
    </div>
  );
}

export default WxappPage; 